<template>
    <article class="venueinfo">
        <div class="venueinfo-banner">
            <img src="../assets/imgs/true.jpg" alt="俱乐部说明">
        </div>
        <header class="venueinfo-header bcw">
            <h1>关于俱乐部的说明</h1>
            <div class="c9 fs1 mtn">今天</div>
        </header>
        <div class="venueinfo-content c6 fs3" v-html="clubInfo.desc"></div>
    </article>
</template>
<script>
export default {
    name: 'VenueInfo',
    data() {
      return {
        clubInfo: {},  
      }
    },
    created() {
        let _this = this;
        // 取团课详情数据
        this.$http.get('club/index?clubId=' + this.$route.params.clubid).then(res => {
          this.clubInfo = res.data.value.clubInfo        
        }) 
    }
}
</script>
<style lang="less" scoped>
body{
    background-color: white;
}
.venueinfo{
    position: relative;
    &-header{
        position: absolute;
        top: 1.1rem; left: 5%;
        width: 90%;
        padding: .1rem;
        border: .01rem solid #eee;
        border-radius: .02rem;
        &>h1{
            font-size: .2rem;
        }
    }
    &-content{
        margin: .15rem;
        padding-top: .2rem;
        line-height: 1.6;
        & p{
            text-indent: 2em;
            margin-bottom: .1rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/VenueInfo.vue